import { render, staticRenderFns } from "./CancelRequestSalaryAdvanceModal .vue?vue&type=template&id=2a0f8fe2&scoped=true"
import script from "./CancelRequestSalaryAdvanceModal .vue?vue&type=script&lang=js"
export * from "./CancelRequestSalaryAdvanceModal .vue?vue&type=script&lang=js"
import style0 from "./CancelRequestSalaryAdvanceModal .vue?vue&type=style&index=0&id=2a0f8fe2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0f8fe2",
  null
  
)

export default component.exports